import { formatDateRangeLabel } from '../utils/courseSchedule'
import type { CourseScheduleLike } from '../utils/courseSchedule'

interface CourseScheduleDatesProps {
  schedule?: CourseScheduleLike
  className?: string
}

function getDateRanges(schedule?: CourseScheduleLike) {
  if (schedule?.dateRanges?.length) {
    return schedule.dateRanges.map((r) => ({
      startDate: String(r.startDate).slice(0, 10),
      endDate: String(r.endDate).slice(0, 10),
    }))
  }
  return []
}

export default function CourseScheduleDates({ schedule, className = '' }: CourseScheduleDatesProps) {
  const ranges = getDateRanges(schedule)
  if (!ranges.length) return null

  return (
    <div className={className}>
      <p className="text-sm font-medium text-gray-600 mb-2">Course date ranges</p>
      <ul className="divide-y divide-gray-100 rounded-lg border border-gray-200 overflow-hidden">
        {ranges.map((r, i) => (
          <li
            key={`${r.startDate}-${r.endDate}-${i}`}
            className="px-4 py-2.5 bg-white text-sm text-gray-800"
          >
            {formatDateRangeLabel(r.startDate, r.endDate)}
          </li>
        ))}
      </ul>
    </div>
  )
}
